import React, {
  useState,
}                           from 'react';
import PropTypes            from 'prop-types';
import moment               from 'moment';
import useStyles            from './styles';
import ArrowForwardIcon     from '@material-ui/icons/ArrowForward';
import ArrowBackIcon        from '@material-ui/icons/ArrowBack';
import { Button }           from '@material-ui/core';
import TextField            from '@material-ui/core/TextField';

function MonthPicker({
  setStartDate,
  setEndDate,
}){
  const [ date, setDate ] = useState(moment());
  const [ month, setMonth ] = useState(moment().startOf('month').format('MMMM'));
  const [ year, setYear ] = useState(moment().endOf('month').format('YYYY'));
  const classes = useStyles();

  const handlePlus = () => {
    if (month) {
      setDate(date.add(1, 'month'));
    }

    formatInput();
  };

  const handleMinus = () => {
    if (month) {
      setDate(date.subtract(1, 'month'));
    }

    formatInput();
  };

  // const handleClear = () => {
  //   setStartDate(moment().subtract(1, 'year').startOf('year').format());
  //   setEndDate(moment().endOf('year').format());
  //   setMonth(null);
  //   setYear(null);
  // };

  const formatInput = () => {
    setMonth(date.format('MMMM'));
    setYear(date.format('YYYY'));
    handleRequest();
  };

  const handleRequest = () => {
    setStartDate(date.startOf('month').format());
    setEndDate(date.endOf('month').format());
  };

  return(
    <div style={{flexDirection: 'row', width: 600, height: 20}}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleMinus()}
      >
        <ArrowBackIcon />
      </Button>

      <TextField
        id="outlined-read-only-input"
        label="Mês de busca"
        value={`${month}, ${year}`}
        InputProps={{
          readOnly: true,
          className: classes.inputDate
        }}
        variant="outlined"
      />

      <Button
        variant="contained"
        color="primary"
        onClick={() => handlePlus()}
      >
        <ArrowForwardIcon />
      </Button>

      {/* {month &&
        <Button
          variant="contained"
          color="secondary"
          onClick={() => handleClear()}
          className={classes.trashButton}
        >
          <DeleteIcon />
        </Button>} */}

    </div>
  );
}

MonthPicker.propTypes={
  setStartDate: PropTypes.func,
  setEndDate: PropTypes.func,
};

export default MonthPicker;
